/* Service-worker registration, and its deliberate absence in dev.

   Production registers /sw.js. Localhost does the opposite and actively tears
   down any worker and cache it finds, so a machine that once ran a build with a
   worker self-heals on the next load instead of serving yesterday's bundle out
   of a cache-first shell — the failure this cost real debugging time to find.

   Registration is fire-and-forget: the app works without a worker, so nothing
   waits on this and nothing reports it failing. */

const DEV_HOSTS = ['localhost', '127.0.0.1', '[::1]'];

/**
 * Opt back in on a dev host: `localStorage['grain:sw'] = '1'`, then reload.
 *
 * Without it there is nowhere to test a worker change. The teardown above owns
 * every dev host; a LAN IP over http is not a secure context so nothing
 * registers there; and the Android runbook's `adb reverse` maps the device
 * straight back onto localhost. That left Railway as the first place a change to
 * sw.js ran, which is not a place to find out.
 *
 * A flag rather than a build define because it has to be switchable on the phone,
 * where there is no build. The default is unchanged — an ordinary dev machine
 * still tears any worker it finds down.
 */
function devOptIn(): boolean {
  try {
    return localStorage.getItem('grain:sw') === '1';
  } catch {
    return false;
  }
}

export function installServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  if (DEV_HOSTS.includes(location.hostname) && !devOptIn()) {
    void navigator.serviceWorker.getRegistrations()
      .then((rs) => Promise.all(rs.map((r) => r.unregister())))
      .catch(() => undefined);
    // Only ours. Blowing away the whole CacheStorage is what let v1's dev
    // teardown reach into caches that were not its own.
    void caches?.keys()
      .then((ks) => Promise.all(
        ks.filter((k) => k.startsWith('grain-') || k.startsWith('iw-')).map((k) => caches.delete(k)),
      ))
      .catch(() => undefined);
    return;
  }

  void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
}
